import React from "react"
import PropTypes from "prop-types"
import { linksResolver } from "../../../utils/linksResolver"
import { Copyright } from "./copyright"
import MyLink from "../../../utils/checkExternalLink"
import { Container } from "../../Container"
import { LatestNews } from "./latestNews"
// import { FAQ } from "./faq"
import styled from "styled-components"
import { FutureEvents } from "./futureEvents"
import { contacts } from "./data"

const Footer = ({ data }) => {
  const { footerBody, latestBlogs, latestQuestions, futureEvents } = data

  const showFooterSection = ["Links", "Latest Blogs"]

  const footerData = footerBody
    .map(item => {
      return {
        label: item.primary.label,
        items: item.items,
      }
    })
    .filter(item => showFooterSection.includes(item.label))
    .reverse()
  return (
    <Wrapper>
      <Container>
        <Grid>
          <Items>
            {contacts.map((item, i) => (
              <ContactItem key={i}>
                <h4>{item.title}</h4>
                <Description>
                  {item?.data?.map((item, i) => (
                    <span key={i} dangerouslySetInnerHTML={{ __html: item }} />
                  ))}
                </Description>
              </ContactItem>
            ))}
            {footerData.map(({ label, items }, i) => (
              <FooterLinks key={i}>
                <h4>{label}</h4>
                <ul>
                  {items.map((item, index) => {
                    const { label, link_url: linkURL } = item
                    return (
                      <li key={index}>
                        {linkURL.type ? (
                          <MyLink
                            href={
                              linkURL.document && linkURL.document.uid
                                ? linksResolver(linkURL.document)
                                : linksResolver(linkURL)
                            }
                          >
                            {label}
                          </MyLink>
                        ) : (
                          <MyLink href={linkURL.url}>{label}</MyLink>
                        )}
                      </li>
                    )
                  })}
                </ul>
              </FooterLinks>
            ))}
            <FutureEvents futureEvents={futureEvents} />
            <LatestNews news={latestBlogs} />
          </Items>
          <SubscribeItem>
            <h4>Join Our Mailing List</h4>
            <Button
              as="a"
              variant="primary"
              href="https://ecr-shrink-group.us17.list-manage.com/subscribe?u=6023bad92de17c3cdf8bb689d&id=fe6105ee15"
              target="_blank"
              rel="noopener noreferrer"
            >
              Subscribe
            </Button>
          </SubscribeItem>
        </Grid>
        <Copyright />
      </Container>
    </Wrapper>
  )
}

export default Footer

Footer.propTypes = {
  data: PropTypes.object.isRequired,
}

const Wrapper = styled.div`
  margin-top: 50px;
  @media (max-width: 768px) {
    margin-top: 10px;
  }
`

const Grid = styled.div`
  margin: 20px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 18px;

  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
  }

  h4 {
    font-size: 12px;
    line-height: 15px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.secondary_color};
    margin: 0;

    @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
      font-size: 16px;
      line-height: 1.6;
    }
  }

  ul {
    li {
      div,
      a {
        font-size: 12px;
        color: ${({ theme }) => theme.colors.secondary_color};
        font-weight: 400;
        line-height: 1.6;

        @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
          font-size: 16px;
        }
      }

      a {
        &:hover,
        &:active,
        &:focus {
          color: ${({ theme }) => theme.colors.secondary_color};
          text-decoration: underline;
        }
      }
    }
  }
`

const Description = styled.div`
  font-size: 12px;
  line-height: 1.6;

  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    font-size: 16px;
  }

  span {
    display: block;
  }
`

const FooterLinks = styled.div`
  text-decoration: underline;
  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    text-align: left;
    width: 48%;
  }
  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    width: 32%;
  }
  @media (max-width: 767px) {
    ul {
      display: flex;
    }
    li {
      margin-right: 5px;
    }
  }
`

const Button = styled.a`
  ${({ theme }) => theme.primaryButton}
`

const Items = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  a {
    text-decoration: underline;
  }

  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    flex-direction: row;
    flex-wrap: wrap;
    width: 90%;
  }
  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    width: 84%;
  }
`

const ContactItem = styled.div`
  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    text-align: left;
    width: 48%;
  }
  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    width: 32%;
  }
`

const SubscribeItem = styled.div`
  h4 {
    margin-bottom: 12px;
  }
  @media (max-width: 767px) {
    display: none;
  }
`
